import { Collections } from "@diacare/common/models/collections";
import { FieldType } from "@litbase/admin";
import { User } from "@styled-icons/boxicons-regular";
import { ExtendedModelConfig } from "./index";

export const userConfig: ExtendedModelConfig = {
  name: Collections.USERS,
  singleName: "User",
  displayName: "Users",
  newLabel: "New user",
  listLabel: "Users",
  icon: User,
  fields: {
    email: { type: FieldType.string, displayName: "Email address" },
    name: { type: FieldType.string, displayName: "Name" },
  },
  queryFields: {},
};
